import styled from 'styled-components';

export default styled.div`
  .ql-editor {
    min-height: 150px;
    max-height: 400px;
  }
`;
